import searchLanding from './pages/search-landing';

searchLanding();
